module.exports = __webpack_public_path__ + "img/prizes.aff7ed8f.png";